var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsNotApplicable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M13.7 4.5h14.7c3.1 0 5.7 2.6 5.7 5.7v21.7c0 3.1-2.6 5.7-5.7 5.7H13.7C10.6 37.6 8 35 8 31.9V10.2c0-3.1 2.6-5.7 5.7-5.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_grey",
    d: "M29.3 14.4H12.8c-.8 0-1.4-.6-1.4-1.4V9.8c0-.8.6-1.4 1.4-1.4h16.5c.8 0 1.4.6 1.4 1.4V13c.1.7-.6 1.4-1.4 1.4zM29.2 24.1H12.7c-.8 0-1.4-.6-1.4-1.4v-3.2c0-.8.6-1.4 1.4-1.4h16.5c.8 0 1.4.6 1.4 1.4v3.2c0 .8-.6 1.4-1.4 1.4zM29.2 33.6H12.7c-.8 0-1.4-.6-1.4-1.4V29c0-.8.6-1.4 1.4-1.4h16.5c.8 0 1.4.6 1.4 1.4v3.2c0 .8-.6 1.4-1.4 1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsNotApplicable);
export default __webpack_public_path__ + "static/media/ps_notApplicable.c4fe028945dbf813bfc84d3d6221b74a.svg";
export { ForwardRef as ReactComponent };